import { transactionID } from "../../services/helpers";
import { baseAPI } from "../../services/api";

export function checkUserPlanProgram({ msisdn, authToken }) {
  return baseAPI.post(
    "/v2/queryProgram",
    {
      transactionId: transactionID("CUP"),
      msisdn,
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
}
